module.exports = __webpack_public_path__ + "static/media/services.c940d87a.png";